module.exports = __webpack_public_path__ + "img/no_toilet_paper.c2cc586e.png";